import Table from '../ui/table/Table'

// Next
import { Link } from 'react-router-dom'

// UI
import CurrentLocation from '../shipments/CurrentLocation'

// API
import { useApiSWRReference } from '@/hooks/useApiSWR'

// Mantine
import { Anchor, RingProgress } from '@mantine/core'

// Dayjs
import dayjs from 'dayjs'
import { name } from 'dayjs/locale/fr'

// Cell
const IdCell = (item) => {
    return (
        <div className="table-cell p-5 align-top">
            <div className="flex flex-col">
                <span className="text-gray-900">#{item.id}</span>
                <pre className="hidden">{JSON.stringify(item, null, 2)}</pre>

                <span className="text-sm text-gray-400 hiddene">
                    {item.name}
                </span>
                <span className="text-sm text-gray-400">
                    {dayjs(item.created_at).format('lll')}
                </span>
            </div>
        </div>
    )
}

const FulfillmentOrderCell = (item) => {
    return (
        <div className="table-cell p-5 align-middle">
            {item.fulfillment_order_id && (
                <Link
                    to={`/fulfillment_orders/${item.fulfillment_order_id}`}
                >
                    <Anchor component="span">
                        BP{item.fulfillment_order_id}
                    </Anchor>
                </Link>
            )}
        </div>
    )
}

const CreatedAtCell = (item) => {
    return (
        <div className="table-cell p-5 align-middle">
            <span className="text-gray-400 text-sm">
                {dayjs(item.created_at).format('lll')}
            </span>
        </div>
    )
}

const LinesCell = (item) => {
    return (
        <div className="table-cell p-5 align-middle">
            <div className="flex flex-col">
                {item.fulfillment_line_items.map((line) => {
                    let label = null

                    if (line.component) {
                        // Component line
                        const categoryName =
                            line.component.component_category?.name_fr
                        label = categoryName
                            ? `${categoryName} — ${line.component.name}`
                            : line.component.name
                    } else if (line.shopify_product_variant?.shopify_product) {
                        // Shopify variant line
                        label = `${line.shopify_product_variant.shopify_product.title} - ${line.shopify_product_variant.title}`
                    }

                    if (!label) return null

                    return (
                        <div key={line.id} className="flex flex-row">
                            <span className="text-gray-500 text-sm">
                                {line.quantity}× {label}
                            </span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

const LocationCell = (item) => {
    return (
        <div className="table-cell p-5 align-middle text-gray-400">
            {item.location.name}
        </div>
    )
}

export default function FulfillmentsTable() {
    // Set columns available for the table
    const availableColumns = [
        {
            name: 'Numéro',
            key: 'id',
            display: 'mandatory',
            sortable: true,
            width: 200,
            component: IdCell,
        },
        {
            name: 'Demande de préparation',
            key: 'fulfillment_order_id',
            display: 'optional_default',
            sortable: true,
            width: 200,
            component: FulfillmentOrderCell,
        },
        {
            name: 'Produits',
            key: 'fulfillment_line_items',
            display: 'optional_default',
            sortable: false,
            component: LinesCell,
        },
        {
            name: 'Lieu de préparation',
            key: 'location_id',
            display: 'optional_default',
            component: LocationCell,
        },
    ]

    // Load filters data
    const { data: locations } = useApiSWRReference('/locations')

    const locationOptions = locations?.map((location) => ({
        value: location.id.toString(),
        label: location.name,
    }))

    const availableFilters = [
        {
            name: 'Lieu de préparation',
            key: 'location_id',
            type: 'multiselect',
            placeholder: 'Sélectionnez un lieu',
            options: locationOptions,
        },
    ]

    return (
        <Table
            availableColumns={availableColumns}
            availableFilters={availableFilters}
            engineApiEndpoint="/fulfillments"
        />
    )
}
